/**
 * Rob's recorded invitation, cut by the question's territory (BRAND_SPEC
 * §10.3: doubt, hurt, silence, grace). The card ("The real Rob · recorded,
 * not AI") appears after the first answer of a campaign landing, above the
 * next-step ladder, once a cut exists here.
 *
 * Empty until the shoot (BRAND_SPEC §20.2 decision 6, launch gate 6): a card
 * with a still and nothing to play would be a broken promise. Each entry:
 *   { src, poster, captions (WebVTT), title, meta: 'A minute from Rob · 1:00 · captions on' }
 */
export const ROB_VIDEOS = {};

export function robVideoFor(territory) {
  const video = territory ? ROB_VIDEOS[territory] : null;
  return video && video.src ? video : null;
}
